<template>
  <div v-if="parentName !== 'ModemTabLayout'">
    <v-row no-gutters>
      <v-text-field
        label="Genişlik"
        v-model="currentItem['genislik']"
        @input="svgDimen"
      />
    </v-row>

    <v-row no-gutters>
      <v-autocomplete
        label="İkon Seç"
        v-model="currentItem['selected_icon']"
        @input="changeIcon"
        item-text="text"
        item-value="id"
        :items="icons"
      />
    </v-row>

    <v-row no-gutters>
      <v-col class="col-6 px-1">
        <v-text-field
          type="number"
          @input="changeLabelSize"
          label="Etiket Yazı Büyüklüğü"
          v-model="currentItem['etiketFontSize']"
        />
      </v-col>
      <v-col class="col-6 px-1">
        <v-text-field
          @input="changeLabel"
          label="Etiket Label"
          v-model="currentItem['elementLabel']"
        />
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-autocomplete
        label="Animasyon Tipi (0 - 1 şeklinde düşünülmeli)"
        :items="animationTypes"
        v-model="currentItem['animation_type']"
      />
    </v-row>

    <v-row no-gutters>
      <v-autocomplete
        v-model="currentItem['bagli_alan']"
        item-text="Text"
        item-value="Id"
        label="Bağlı Alan"
        :items="bagliAlanItems"
      />
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  changeSvgDimension,
  findBinaryValue
} from "@/components/ModemLayoutWizard/ModemLayoutSettings/svgComponentUtils/svgUtilFunctions";
import store from "@/vuex_store/store_wrapper";

export default {
  name: "yatayEtiketStd",
  props: {
    currentItem: {
      type: Object,
      required: false
    },
    modemID: {
      type: [Array, Number],
      required: false
    },
    //from modem tab layout
    parentName: String,
    svgItemObject: {
      type: Object,
      required: false
    },
    listSetup: Object,
    dataProperty: Object
  },
  data() {
    return {
      icons: [
        {
          id: 0,
          text: "Servis Dışı",
          path:
            "M71 43C58.281 43 48 53.281 48 66C48 78.719 58.281 89 71 89C83.719 89 94 78.719 94 66C94 53.281 83.719 43 71 43ZM82.5 74.257L79.257 77.5L71 69.243L62.743 77.5L59.5 74.257L67.757 66L59.5 57.743L62.743 54.5L71 62.757L79.257 54.5L82.5 57.743L74.243 66L82.5 74.257Z"
        },
        {
          id: 1,
          text: "Şebeke",
          path:
            "M87.8518 59.7935C87.7524 59.6196 87.6082 59.4749 87.434 59.3742C87.2597 59.2736 87.0617 59.2205 86.86 59.2205H71.9268L74.4304 40.2553C74.4573 40.0015 74.3972 39.7461 74.2599 39.5302C74.1225 39.3144 73.9159 39.1506 73.6733 39.0653C73.4307 38.9801 73.1662 38.9782 72.9224 39.0601C72.6786 39.142 72.4696 39.3028 72.3292 39.5167L54.1689 71.0605C54.0627 71.2318 54.0045 71.428 54.0002 71.629C53.996 71.83 54.046 72.0284 54.1449 72.2039C54.2438 72.3794 54.3882 72.5255 54.5631 72.6273C54.738 72.729 54.937 72.7826 55.1398 72.7827H69.8499L67.8658 91.7764C67.8463 92.0294 67.9127 92.2815 68.0544 92.4927C68.1961 92.7039 68.405 92.8621 68.6478 92.9421C68.8907 93.022 69.1535 93.0191 69.3945 92.9339C69.6355 92.8487 69.8408 92.686 69.9778 92.4718L87.8381 60.9313C87.9417 60.7598 87.9975 60.5641 87.9999 60.3643C88.0023 60.1644 87.9512 59.9674 87.8518 59.7935Z"
        },
        {
          id: 2,
          text: "Revizyon",
          path:
            "M94.8492 63.3356C94.7735 62.6609 93.9865 62.1534 93.306 62.1534C91.1069 62.1534 89.1552 60.8626 88.3366 58.8648C87.5011 56.8191 88.0402 54.4338 89.6787 52.9307C90.1947 52.4588 90.2576 51.6688 89.825 51.1203C88.6991 49.6909 87.4199 48.3995 86.0229 47.2805C85.4763 46.842 84.6732 46.9031 84.1988 47.4281C82.7684 49.0123 80.1987 49.601 78.2129 48.7726C76.1472 47.9034 74.8434 45.8095 74.9714 43.562C75.0136 42.8556 74.4971 42.2418 73.7932 42.1598C72.0003 41.9522 70.1916 41.9462 68.3935 42.1457C67.6985 42.2225 67.1824 42.8218 67.2054 43.5193C67.2833 45.7448 65.9647 47.8017 63.9189 48.6397C61.9571 49.4412 59.4052 48.8568 57.9776 47.2865C57.5058 46.7692 56.7168 46.7057 56.1665 47.1347C54.7283 48.2634 53.4203 49.5556 52.284 50.9734C51.8412 51.5245 51.9066 52.3233 52.427 52.7968C54.0979 54.3098 54.6365 56.7157 53.769 58.7853C52.9408 60.7584 50.8921 62.0294 48.547 62.0294C47.786 62.0049 47.2444 62.5162 47.1603 63.2083C46.9494 65.0107 46.9472 66.8483 47.1502 68.6655C47.2259 69.343 48.0361 69.8462 48.7241 69.8462C50.8145 69.793 52.8202 71.0863 53.6628 73.1345C54.5012 75.1802 53.9615 77.5645 52.3203 79.0697C51.8069 79.5416 51.7413 80.3297 52.1748 80.8776C53.2893 82.298 54.5697 83.5903 55.9709 84.7189C56.521 85.1619 57.321 85.0998 57.7979 84.5742C59.2339 82.9862 61.8032 82.3985 63.7809 83.2286C65.8526 84.0955 67.1558 86.1892 67.0286 88.4373C66.9869 89.1437 67.5046 89.7594 68.206 89.8395C69.1235 89.9469 70.0458 90 70.9711 90C71.8491 90 72.7274 89.9521 73.6057 89.8543C74.3016 89.7775 74.8168 89.1776 74.7933 88.4799C74.713 86.2554 76.0345 84.1983 78.0778 83.3619C80.0527 82.5552 82.5932 83.1456 84.0216 84.7137C84.4959 85.23 85.2801 85.2926 85.8327 84.8652C87.2684 83.7395 88.5739 82.4479 89.7152 81.0264C90.1584 80.4763 90.0955 79.6765 89.5722 79.2022C87.9017 77.6901 87.3602 75.2832 88.2277 73.2157C89.0431 71.2692 91.0155 69.9622 93.1371 69.9622L93.4339 69.9701C94.1227 70.026 94.7556 69.4956 94.8388 68.7929C95.0508 66.9888 95.0531 65.1534 94.8492 63.3356ZM70.9999 79.8363C63.3581 79.8363 57.1635 73.6418 57.1635 66.0003C57.1635 58.3587 63.3583 52.1643 70.9999 52.1643C78.6416 52.1643 84.8363 58.3587 84.8363 66.0003C84.8363 68.594 84.1212 71.0201 82.8792 73.0947L76.8206 67.0359C77.2592 66.0017 77.4909 64.8806 77.4907 63.7235C77.4907 61.4578 76.6083 59.3277 75.0059 57.7258C73.404 56.1239 71.2739 55.2417 69.0085 55.2417C68.2525 55.2417 67.5 55.3422 66.772 55.5404C66.4532 55.6274 66.1924 55.8902 66.1075 56.2096C66.0208 56.5364 66.1185 56.8712 66.3739 57.1267C66.3739 57.1267 69.365 60.1408 70.3657 61.1414C70.4706 61.2462 70.4704 61.4964 70.4556 61.5865L70.4463 61.6523C70.3454 62.7525 70.1509 64.0731 69.9904 64.5806C69.9688 64.602 69.9485 64.6201 69.9265 64.6421C69.9034 64.6651 69.8823 64.6873 69.8601 64.7102C69.3459 64.8752 68.0049 65.072 66.8872 65.172L66.8874 65.166L66.8372 65.1787C66.8283 65.1797 66.8117 65.181 66.7897 65.181C66.6688 65.181 66.4911 65.1471 66.3296 64.9858C65.288 63.9442 62.4142 61.091 62.4142 61.091C62.1563 60.834 61.8919 60.78 61.7156 60.78C61.3048 60.78 60.937 61.0768 60.8211 61.5026C60.03 64.4301 60.8687 67.5792 63.0103 69.721C64.6127 71.3231 66.7429 72.2054 69.0087 72.2054C70.1658 72.2054 71.287 71.9739 72.321 71.5353L78.4454 77.6596C76.2952 79.0355 73.7419 79.8363 70.9999 79.8363Z"
        },
        {
          id: 3,
          text: "Kat Kapı",
          path:
            "M78.6574 42.0334C79.2957 41.9209 79.951 42.0957 80.4475 42.5103C80.9441 42.9251 81.2307 43.537 81.2307 44.1819V46.3656V48.5474V50.7293V81.2727V83.4546V85.6364V87.366V87.8183C81.2307 88.4633 80.9441 89.0751 80.4476 89.4896C80.0498 89.8218 79.5498 90 79.0384 90C78.9117 90 78.7844 89.989 78.6575 89.9668L53.8114 85.6032C52.7638 85.4194 52 84.5133 52 83.4546V48.5482C52 47.4895 52.7637 46.5836 53.8113 46.3996L78.6574 42.0334ZM70.2692 69.6363C70.8464 69.6363 71.4122 69.4037 71.8198 68.9978C72.2275 68.5907 72.4615 68.0293 72.4616 67.4545C72.4616 66.88 72.2276 66.3185 71.8198 65.9114C71.4122 65.5053 70.8464 65.2727 70.2692 65.2727C69.6919 65.2727 69.1277 65.5054 68.7185 65.9114C68.3107 66.3183 68.0769 66.88 68.0769 67.4545C68.0769 68.0292 68.3107 68.5906 68.7185 68.9976C69.1278 69.4036 69.692 69.6363 70.2692 69.6363ZM87.8077 46.3637C88.3892 46.3637 88.9467 46.5934 89.3577 47.0025C89.769 47.4117 89.9999 47.9667 90 48.5455V83.4545C90 84.6595 89.0184 85.6364 87.8077 85.6364H85.6154V83.4545V81.2727V50.7281V48.5463V46.3644L87.8071 46.3637H87.8077Z"
        },
        {
          id: 4,
          text: "Uyku",
          path:
            "M77 43C81.186 43 85.119 44.15 88.5 46.105C81.623 50.084 77 57.49 77 66C77 74.51 81.623 81.916 88.5 85.895C85.119 87.85 81.186 89 77 89C64.304 89 54 78.696 54 66C54 53.304 64.304 43 77 43Z"
        },
        {
          id: 5,
          text: "Alarm",
          path:
            "M84.5833 65.5937C84.5833 69.3867 86.2451 72.9671 89.1431 75.4166C89.9059 76.0702 90.3333 76.9978 90.3333 77.9791C90.3333 79.8287 88.8287 81.3333 86.9791 81.3333H55.3542C53.5046 81.3333 52 79.8287 52 77.9791C52 76.9978 52.4274 76.0702 53.173 75.4319C56.0882 72.9671 57.75 69.3867 57.75 65.5937V60.25C57.75 53.5052 62.7582 47.922 69.25 46.9867V44.9167C69.25 43.8567 70.1087 43 71.1667 43C72.2247 43 73.0833 43.8567 73.0833 44.9167V46.9867C79.5732 47.922 84.5833 53.5052 84.5833 60.25V65.5937ZM78.2085 83.2502C77.5415 86.5257 74.6378 89.0001 71.1667 89.0001C67.6956 89.0001 64.7919 86.5257 64.1249 83.2502H78.2085Z"
        },
        {
          id: 6,
          text: "Isıtıcı",
          path:
            "M78.1666 68.9283V50.6666C78.1666 46.4325 74.7342 43 70.5 43C66.2658 43 62.8334 46.4325 62.8334 50.6666V68.9282C60.4806 71.0339 59 74.0941 59 77.5C59 83.8513 64.1488 89 70.5 89C76.8512 89 82 83.8513 82 77.5C82 74.0941 80.5194 71.0339 78.1666 68.9283ZM70.5 85.1666C66.2658 85.1666 62.8334 81.7342 62.8334 77.5C62.8334 75.2865 63.7714 73.2331 65.3899 71.7846L66.6667 70.6418V50.6666C66.6667 48.5496 68.383 46.8333 70.5001 46.8333C72.6172 46.8333 74.3335 48.5495 74.3335 50.6666V70.6418L75.6103 71.7846C77.2288 73.2331 78.1668 75.2864 78.1668 77.5C78.1666 81.7342 74.7342 85.1666 70.5 85.1666ZM72.4167 58.3333H68.5833V72.0772C66.35 72.8665 64.75 74.9964 64.75 77.5C64.75 80.6756 67.3244 83.25 70.5 83.25C73.6756 83.25 76.25 80.6756 76.25 77.5C76.25 74.9964 74.65 72.8666 72.4167 72.0772V58.3333Z"
        },
        {
          id: 7,
          text: "Pompa",
          path:
            "M60.5781 45.6953H59.2305C58.4862 45.6953 57.8828 45.092 57.8828 44.3477C57.8828 43.6033 58.4862 43 59.2305 43H71.8086C72.5529 43 73.1562 43.6033 73.1562 44.3477C73.1562 45.092 72.5529 45.6953 71.8086 45.6953H70.4609V49.2891H60.5781V45.6953ZM77.6484 51.5352C77.6484 50.7908 77.045 50.1875 76.3008 50.1875C75.5565 50.1875 74.9531 50.7908 74.9531 51.5352V51.9844H56.0859V51.5352C56.0859 50.7908 55.4825 50.1875 54.7383 50.1875C53.994 50.1875 53.3906 50.7908 53.3906 51.5352V51.9844H52.9414C50.2167 51.9844 48 54.2012 48 56.9258V69.5039C48 72.2285 50.2167 74.4453 52.9414 74.4453H53.3906V74.8945C53.3906 75.6389 53.994 76.2422 54.7383 76.2422C55.4825 76.2422 56.0859 75.6389 56.0859 74.8945V74.4453H74.9531V74.8945C74.9531 75.6389 75.5565 76.2422 76.3008 76.2422C77.045 76.2422 77.6484 75.6389 77.6484 74.8945V74.4453H78.0977C80.8224 74.4453 83.0391 72.2285 83.0391 69.5039V56.9258C83.0391 54.2012 80.8224 51.9844 78.0977 51.9844H77.6484V51.5352ZM77.6484 51.9844V74.4453H74.9531V51.9844H77.6484ZM56.0859 74.4453H53.3906V51.9844H56.0859V74.4453ZM91.3047 60.5195H92.6523C93.3966 60.5195 94 61.1228 94 61.8672V64.5625C94 65.3069 93.3966 65.9102 92.6523 65.9102H91.3047V60.5195ZM85.7344 57.8242C87.223 57.8242 88.4297 59.031 88.4297 60.5195V65.9102C88.4297 67.3987 87.223 68.6055 85.7344 68.6055V57.8242ZM70.0117 69.9531H61.0273C60.2831 69.9531 59.6797 69.3499 59.6797 68.6055C59.6797 67.8611 60.2831 67.2578 61.0273 67.2578H70.0117C70.756 67.2578 71.3594 67.8611 71.3594 68.6055C71.3594 69.3499 70.756 69.9531 70.0117 69.9531ZM70.0117 64.5625H61.0273C60.2831 64.5625 59.6797 63.9592 59.6797 63.2148C59.6797 62.4705 60.2831 61.8672 61.0273 61.8672H70.0117C70.756 61.8672 71.3594 62.4705 71.3594 63.2148C71.3594 63.9592 70.756 64.5625 70.0117 64.5625ZM70.0117 59.1719H61.0273C60.2831 59.1719 59.6797 58.5686 59.6797 57.8242C59.6797 57.0798 60.2831 56.4766 61.0273 56.4766H70.0117C70.756 56.4766 71.3594 57.0798 71.3594 57.8242C71.3594 58.5686 70.756 59.1719 70.0117 59.1719ZM58.7715 80.9141L60.002 77.1406H71.0371L72.2676 80.9141H58.7715ZM48 87.6523C48 88.3967 48.6034 89 49.3477 89H81.6914C82.4357 89 83.0391 88.3967 83.0391 87.6523C83.0391 85.4194 81.229 83.6094 78.9961 83.6094H52.043C49.8101 83.6094 48 85.4194 48 87.6523Z"
        },
        {
          id: 9,
          text: "Termik",
          path:
            "M89.1953 59.8607V43H55.8334V49.7083H52V60.0703H55.8334V68.4857H52V78.8477H55.8334V85.556H64.115V89H67.8577V85.556H70.553V89H74.4755V85.556H77.1708V89H80.9137V85.556H89.1953V68.6953H83.8047V80.1654H61.224V48.3906H83.8047V59.8607H89.1953ZM89.1953 62.5563H83.8649V66H89.1953V62.5563ZM63.9193 77.4701V51.0859H81.1094V77.4701H63.9193ZM71.0307 67.609L73.0396 68.6136L75.769 63.155H72.894L73.998 60.9469L71.9891 59.9424L69.2597 65.401H72.1347L71.0307 67.609Z"
        }
      ],
      bagliAlanItems: [],
      unsubscribe: null,
      // 0 - 1 şeklinde düşünülmeli
      animationTypes: [
        "Kırmızı-Yeşil",
        "Yeşil-Kırmızı",
        "Gri-Yeşil",
        "Yeşil-Gri"
      ],
      colors: {
        kirmiziYesil: ["#FA5151", "#24C263"],
        yesilKirmizi: ["#24C263", "#FA5151"],
        yesilGri: ["#24C263", "#DCDCDC"],
        griYesil: ["#DCDCDC", "#24C263"]
      },
      etiketValue: "0"
    };
  },
  computed: {
    ...mapGetters({
      getterSVGScaleInfo: "storeSVGScale/getterSVGScaleInfo"
    }),
    svgDimen: function() {
      return changeSvgDimension(this.currentItem);
    },
    getBaseGroupId: function() {
      if (this.parentName === "ModemTabLayout") {
        return document
          .getElementById(this.svgItemObject["id"])
          .getElementsByTagName("svg")[0];
      } else {
        return document
          .getElementById(this.currentItem["id"])
          .getElementsByTagName("svg")[0];
      }
    },
    getEtiket: function() {
      const svgBase = this.getBaseGroupId;
      return svgBase.querySelector("#horizontal_etiket_label");
    },
    getIcon: function() {
      const svgBase = this.getBaseGroupId;
      return svgBase.querySelector("#horizontal_etiket_icon");
    },
    getBase: function() {
      const svgBase = this.getBaseGroupId;
      const baseG = svgBase.querySelector("#horizontal_etiket_base");
      return baseG.getElementsByTagName("rect")[0];
    }
  },
  beforeDestroy() {
    this.unsubscribe && this.unsubscribe();
  },
  created() {
    this.unsubscribe = store.subscribe(this.storeHandler);
    if (this.parentName !== "ModemTabLayout") {
      this.getBagliAlanInputs();
    }
  },
  mounted() {
    this.parentName === "ModemTabLayout" &&
      this.setScadaData(this.dataProperty["Id"], this.dataProperty["Datas"]);
  },
  methods: {
    storeHandler: function(mutation) {
      const { type, payload } = mutation;
      if (type === "storeSocket/on_socket_message") {
        const { data, command } = JSON.parse(payload.data);
        if (command === "ModemIOList") {
          const { TargetID, Elements } = data;
          const { id } =
            this.parentName === "ModemLayoutWizard"
              ? this.currentItem
              : this.svgItemObject;
          if (id === TargetID) {
            console.log("Modem Inputlar", data);
            this.bagliAlanItems = Object.keys(Elements).map(key => {
              return {
                Text: Elements[key],
                Id: key
              };
            });
          }
        } else if (command === "ProcessData") {
          const { ModemId, Datas } = data;
          //console.log("DATA Pompa Etiket => ", data);
          if (ModemId === this.modemID) {
            this.setScadaData(ModemId, Datas);
          }
        }
      }
    },
    setScadaData: function(ModemId, Datas) {
      if (Object.keys(Datas).length > 0) {
        const { bagli_alan } = this.svgItemObject;
        const [tip, master, bit] = bagli_alan.split("_");
        if (Datas.hasOwnProperty(`${tip}_${master}`)) {
          console.log("Input Yatay Etiket MasterId Bit", tip, master, bit);
          this.etiketValue = findBinaryValue(Datas[`${tip}_${master}`], bit);
          console.log("Input Yatay Etiket Value", this.etiketValue);
          this.yatayEtiketAnim();
        }
      }
    },
    yatayEtiketAnim: function() {
      const { animation_type } = this.svgItemObject;
      switch (animation_type) {
        case "Kırmızı-Yeşil":
          this.kirmiziYesilAnim();
          break;
        case "Yeşil-Kırmızı":
          this.yesilKirmiziAnim();
          break;
      }
    },
    kirmiziYesilAnim: function() {
      if (this.etiketValue === "0") {
        //Kırmızı
        this.getBase.setAttribute(
          "style",
          `transition:.2s ease-in-out; fill: ${this.colors.kirmiziYesil[0]}`
        );
      } else if (this.etiketValue === "1") {
        //Yeşil
        this.getBase.setAttribute(
          "style",
          `transition:.2s ease-in-out; fill: ${this.colors.kirmiziYesil[1]}`
        );
      }
    },
    yesilKirmiziAnim: function() {
      if (this.etiketValue === "0") {
        //Yeşil
        this.getBase.setAttribute(
          "style",
          `transition:.2s ease-in-out; fill: ${this.colors.yesilKirmizi[0]}`
        );
      } else if (this.etiketValue === "1") {
        //Kırmızı
        this.getBase.setAttribute(
          "style",
          `transition:.2s ease-in-out; fill: ${this.colors.yesilKirmizi[1]}`
        );
      }
    },
    changeIcon: function(v) {
      const iconPath = this.icons.filter(a => a.id === v)[0].path;
      this.getIcon.setAttribute("d", iconPath);
    },
    changeLabel: function() {
      const tspan = this.getEtiket.getElementsByTagName("tspan")[0];
      tspan.innerHTML = this.currentItem["elementLabel"];
    },
    changeLabelSize: function() {
      this.getEtiket.setAttribute(
        "font-size",
        String(this.currentItem["etiketFontSize"])
      );
    },
    getBagliAlanInputs: function() {
      let getModemIOList = {
        type: "getModemIOList",
        payload: {
          TargetID: this.currentItem["id"],
          ModemId: parseInt(this.modemID[0]),
          Secim: "1"
        }
      };
      this.sendMessageToWS(getModemIOList);
    }
  }
};
</script>

<style scoped></style>
